module.exports = __webpack_public_path__ + "static/media/Q1.53bd838a.png";